import { render, staticRenderFns } from "./RelaunchPickl.vue?vue&type=template&id=0c1a5235&scoped=true&"
import script from "./RelaunchPickl.vue?vue&type=script&lang=js&"
export * from "./RelaunchPickl.vue?vue&type=script&lang=js&"
import style0 from "./RelaunchPickl.vue?vue&type=style&index=0&id=0c1a5235&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1a5235",
  null
  
)

export default component.exports